"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var StateV1Factory = /** @class */ (function (_super) {
    __extends(StateV1Factory, _super);
    function StateV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    StateV1Factory.prototype.deploy = function (_core, _collateralAsset, _syntheticAsset, _oracle, _marketParams, _riskParams, overrides) {
        return _super.prototype.deploy.call(this, _core, _collateralAsset, _syntheticAsset, _oracle, _marketParams, _riskParams, overrides || {});
    };
    StateV1Factory.prototype.getDeployTransaction = function (_core, _collateralAsset, _syntheticAsset, _oracle, _marketParams, _riskParams, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _core, _collateralAsset, _syntheticAsset, _oracle, _marketParams, _riskParams, overrides || {});
    };
    StateV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StateV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StateV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return StateV1Factory;
}(contracts_1.ContractFactory));
exports.StateV1Factory = StateV1Factory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                internalType: "address",
                name: "_collateralAsset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_syntheticAsset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "collateralRatio",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationUserFee",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationArcFee",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.MarketParams",
                name: "_marketParams",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "collateralLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "syntheticLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "positionCollateralMinimum",
                        type: "uint256",
                    },
                ],
                internalType: "struct TypesV1.RiskParams",
                name: "_riskParams",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "collateralRatio",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationUserFee",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationArcFee",
                        type: "tuple",
                    },
                ],
                indexed: false,
                internalType: "struct TypesV1.MarketParams",
                name: "updatedMarket",
                type: "tuple",
            },
        ],
        name: "MarketParamsUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updatedOracle",
                type: "address",
            },
        ],
        name: "OracleUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "collateralLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "syntheticLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "positionCollateralMinimum",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct TypesV1.RiskParams",
                name: "updatedParams",
                type: "tuple",
            },
        ],
        name: "RiskParamsUpdated",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "enum TypesV1.AssetType",
                name: "borrowedAsset",
                type: "uint8",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "parSupply",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "parBorrow",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "price",
                type: "tuple",
            },
        ],
        name: "calculateCollateralDelta",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "price",
                type: "tuple",
            },
        ],
        name: "calculateInverseAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "price",
                type: "tuple",
            },
        ],
        name: "calculateInverseRequired",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
        ],
        name: "calculateLiquidationPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "calculateLiquidationSplit",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "collateralAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "core",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
        ],
        name: "getAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getPosition",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "collateralAsset",
                        type: "uint8",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "borrowedAsset",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "collateralAmount",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "borrowedAmount",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.Position",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "collateralAsset",
                        type: "uint8",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "borrowedAsset",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "collateralAmount",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "borrowedAmount",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.Position",
                name: "position",
                type: "tuple",
            },
        ],
        name: "isCollateralized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "market",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "collateralRatio",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "liquidationUserFee",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "liquidationArcFee",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract IOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "positionCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "positions",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "enum TypesV1.AssetType",
                name: "collateralAsset",
                type: "uint8",
            },
            {
                internalType: "enum TypesV1.AssetType",
                name: "borrowedAsset",
                type: "uint8",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "collateralAmount",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "borrowedAmount",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "risk",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "syntheticLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "positionCollateralMinimum",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "collateralAsset",
                        type: "uint8",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "borrowedAsset",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "collateralAmount",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "borrowedAmount",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.Position",
                name: "position",
                type: "tuple",
            },
        ],
        name: "savePosition",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "amount",
                type: "tuple",
            },
        ],
        name: "setAmount",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "collateralAsset",
                        type: "uint8",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "borrowedAsset",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "collateralAmount",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "borrowedAmount",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.Position",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "collateralRatio",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationUserFee",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct Decimal.D256",
                        name: "liquidationArcFee",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.MarketParams",
                name: "_marketParams",
                type: "tuple",
            },
        ],
        name: "setMarketParams",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "setOracle",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "collateralLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "syntheticLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "positionCollateralMinimum",
                        type: "uint256",
                    },
                ],
                internalType: "struct TypesV1.RiskParams",
                name: "_riskParams",
                type: "tuple",
            },
        ],
        name: "setRiskParams",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "syntheticAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalLiquidationSpread",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupplied",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "enum TypesV1.AssetType",
                name: "asset",
                type: "uint8",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "sign",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "value",
                        type: "uint128",
                    },
                ],
                internalType: "struct TypesV1.Par",
                name: "amount",
                type: "tuple",
            },
        ],
        name: "updatePositionAmount",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "collateralAsset",
                        type: "uint8",
                    },
                    {
                        internalType: "enum TypesV1.AssetType",
                        name: "borrowedAsset",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "collateralAmount",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "bool",
                                name: "sign",
                                type: "bool",
                            },
                            {
                                internalType: "uint128",
                                name: "value",
                                type: "uint128",
                            },
                        ],
                        internalType: "struct TypesV1.Par",
                        name: "borrowedAmount",
                        type: "tuple",
                    },
                ],
                internalType: "struct TypesV1.Position",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "updateTotalSupplied",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=StateV1Factory.js.map